import {OrderReadyQualifierEntityModel} from "../order-ready-qualifier-entity-model.service";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {ChangeDetectorRef, Component} from "@angular/core";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-order-ready-qualifier-edit-page",
    templateUrl: "./order-ready-qualifier-edit-page.component.html",
    providers: [provideEntityModel(OrderReadyQualifierEntityModel)]
})
export class OrderReadyQualifierEditPageComponent extends AbstractEditPage {
    constructor(public model: OrderReadyQualifierEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }
}
